import React, { useState } from 'react'
import { Row } from 'react-flexbox-grid'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'
import { updateQuery, useMutation } from 'components/graphql'
import Button from 'components/Button'
import { Modal } from 'components/Modal'
import { Text } from 'components/forms'
import { ItemView, SideList, StyledColList, StyledColItem } from 'components/SectionHandler'
import { createFreeDay, listHolidays } from './gql'

const StyledRow = styled(Row)`
	${StyledColItem} {
		max-width: ${() => `calc(100% - 360px)`};
	}
`

const CashRegistersHandler = props => {
	const [t] = useTranslation()
	const [showModal, setShowModal] = useState(false)
	const [newFreeDay, setNewFreeDay] = useState('')

	const { listQueryRef, sectionData, history, section } = props
	const { current } = listQueryRef
	const [mutateList] = useMutation(createFreeDay, { onCompleted: (data) => history.push({ pathname: `/optionen/kasse-global/${section}/${data[getNameOfGqlQuery(createFreeDay)].id}` }) })

	const currentDate = moment().format('YYYY-MM-DD')
	const currentDay = moment().locale('en').format('dddd').toUpperCase()

	const handleCreateItem = () => {
		mutateList({
			variables: { fields: { date: currentDate, day: currentDay, name: newFreeDay } },
			update: updateQuery({ query: listHolidays, variables: current?.variables }, (draft, { mutationResult = {}, readQuery, queryField }) => {
				const newLists = [...readQuery.items, mutationResult]
				draft[queryField].items = newLists
			}),
			optimisticResponse: {
				__typename: 'Mutation',
				cashAssist: {
					__typename: 'CA_Mutation'
				}
			}
		})
		setNewFreeDay('')
		setShowModal(false)
	}

	return(
		<>
			<StyledRow>
				<StyledColList xs width='360px' style={{ marginRight: '1rem' }}>
					<SideList
						{...props}
						xs={0}
						fixSidebar={false}
						datatableProps={{
							rowMenu: [],
							remoteOptions: {
								queryRef: listQueryRef,
								query: sectionData.listQuery
							},
							defaultSorted: [{
								id: 'date',
								desc: true
							}],
							onAddRecord: () => setShowModal(true)
						}}
					/>
				</StyledColList>
				<ItemView
					{...props}
				/>
			</StyledRow>
			{showModal &&
				<Modal label={t('options_section.strings.create_new_day')} unmount={() => setShowModal(false)}>
					<Text
						noForm
						value={newFreeDay}
						label={t('options_section.fields.day_name')}
						onChange={(e) => setNewFreeDay(e.target.value)}
					/>
					<Button
						status={newFreeDay.length ? 'primary' : 'inactive'}
						text={t('common.buttons.create')}
						onClick={handleCreateItem}
					/>
				</Modal>
			}
		</>
	)
}

export default CashRegistersHandler
